import { Transition } from "@headlessui/react"
import { Fragment } from "react"

export const CommonTransition = ({open, durationEnter, durationExit, enterFrom, enterTo, exitFrom,exitTo, children}) => {

    return <>
    <Transition
          as={Fragment}
          show={open}
          enter={`transform transition ease-in-out ${durationEnter}`}
          enterFrom={`opacity-0 ${enterFrom}`}
          enterTo={`opacity-100 ${enterTo}`}
          leave={`transform transition ease-in-out ${durationExit}`}
          leaveFrom={`opacity-100 ${exitFrom}`}
          leaveTo={`opacity-0 ${exitTo}`}
        >
        {children}
    </Transition>
    </>
}